import {
  GetMeclisUyeleriResponse,
  GetMuhtarlarResponse,
  GetVicePresidentsResponse,
} from "../models/Response/PortalPeople";
import api from "./axiosInstance";
import { ApiBaseResponse } from "../models/Common/ApiBaseResponse";
import {
  GetActiveAnnouncementsResponse,
  GetActiveTendersResponse,
  GetContentResponse,
  GetEventDetailResponse,
  GetEventsResponse,
  GetHomePageDataResponse,
  GetLastNewsInPressResponse,
  GetMeclisGundemiResponse,
  GetMeclisKararlariResponse,
  GetNewsByDateResponse,
  GetNewsDetailResponse,
  GetNewsInPressDetailResponse,
  GetProjectsResponse,
  GetServiceListResponse,
  GetTenderDetailResponse,
  ProjectDetailResponse,
  GetMaliYonetimResponse,
} from "models/Response/Portal";

const API_URL = "/Portal";

const PortalApi = {
  getNewsDetail: async (id: number): Promise<ApiBaseResponse<GetNewsDetailResponse> | null> => {
    try {
      const response = await api.get<ApiBaseResponse<GetNewsDetailResponse>>(`${API_URL}/GetNewsDetail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  },
  getNewsByDate: async (year: number, month: number): Promise<ApiBaseResponse<GetNewsByDateResponse> | null> => {
    try {
      const response = await api.get<ApiBaseResponse<GetNewsByDateResponse>>(
        `${API_URL}/GetNewsByDate/${year}/${month}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  },
  getActiveTenders: async (): Promise<GetActiveTendersResponse | null> => {
    try {
      const response = await api.get<{ content: GetActiveTendersResponse }>(`${API_URL}/GetActiveTenders`);
      return response.data.content;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  },
  getTenderDetail: async (id: number): Promise<GetTenderDetailResponse | null> => {
    try {
      const response = await api.get<{ content: GetTenderDetailResponse }>(`${API_URL}/GetTenderDetail/${id}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getDashboardData:", error);
      return null;
    }
  },
  getLastNewsInPress: async (): Promise<GetLastNewsInPressResponse | null> => {
    try {
      const response = await api.get<{ content: GetLastNewsInPressResponse }>(`${API_URL}/GetLAstNewsInPress`);
      return response.data.content;
    } catch (error) {
      console.error("Error getDashboardData:", error);
      return null;
    }
  },
  getLastNewsInPressDetail: async (id: number): Promise<GetNewsInPressDetailResponse | null> => {
    try {
      const response = await api.get<{ content: GetNewsInPressDetailResponse }>(
        `${API_URL}/GetNewsInPressDetail/${id}`,
      );
      return response.data.content;
    } catch (error) {
      console.error("Error getDashboardData:", error);
      return null;
    }
  },
  getActiveAnnouncements: async (): Promise<GetActiveAnnouncementsResponse | null> => {
    try {
      const response = await api.get<{ content: GetActiveAnnouncementsResponse }>(`${API_URL}/GetActiveAnnouncements`);
      return response.data.content;
    } catch (error) {
      console.error("Error getDashboardData:", error);
      return null;
    }
  },
  getContent: async (id: number): Promise<GetContentResponse | null> => {
    try {
      const response = await api.get<{ content: GetContentResponse }>(`${API_URL}/GetContent/${id}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getContent:", error);
      return null;
    }
  },
  getServiceList: async (categoryID: number): Promise<GetServiceListResponse | null> => {
    try {
      const response = await api.get<{ content: GetServiceListResponse }>(`${API_URL}/GetServiceList/${categoryID}`);
      return response.data.content;
    } catch (error) {
      console.error("Error GetServiceList:", error);
      return null;
    }
  },
  getHomePageData: async (): Promise<GetHomePageDataResponse | null> => {
    try {
      const response = await api.get<{ content: GetHomePageDataResponse }>(`${API_URL}/GetHomePageData`);
      return response.data.content;
    } catch (error) {
      console.error("Error GetHomePageData:", error);
      return null;
    }
  },
  getProjects: async (projectType: number): Promise<GetProjectsResponse | null> => {
    try {
      const response = await api.get<{ content: GetProjectsResponse }>(`${API_URL}/GetProjects/${projectType}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getProjects:", error);
      return null;
    }
  },
  getProjectDetail: async (projectID: number): Promise<ProjectDetailResponse | null> => {
    try {
      const response = await api.get<{ content: ProjectDetailResponse }>(`${API_URL}/GetProjectDetail/${projectID}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getProjectDetail:", error);
      return null;
    }
  },
  getEvents: async (year: number, month: number): Promise<ApiBaseResponse<GetEventsResponse> | null> => {
    try {
      const response = await api.get<ApiBaseResponse<GetEventsResponse>>(`${API_URL}/GetEvents/${year}/${month}`);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  },
  getEventDetail: async (id: number): Promise<GetEventDetailResponse | null> => {
    try {
      const response = await api.get<{ content: GetEventDetailResponse }>(`${API_URL}/GetEventDetail/${id}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getDashboardData:", error);
      return null;
    }
  },
  getMeclisGundemi: async (id: number): Promise<GetMeclisGundemiResponse | null> => {
    try {
      const response = await api.get<{ content: GetMeclisGundemiResponse }>(`${API_URL}/GetMeclisGundemi/${id}`);
      return response.data.content;
    } catch (error) {
      console.error("Error getMeclisGundemi:", error);
      return null;
    }
  },
  getMeclisKararlari: async (id: number): Promise<GetMeclisKararlariResponse | null> => {
    try {
      const response = await api.get<{ content: GetMeclisKararlariResponse }>(`${API_URL}/GetMeclisKararlari/${id}`);
      return response.data.content;
    } catch (error) {
      console.error("Error GetMeclisKararlari:", error);
      return null;
    }
  },
  getMaliYonetim: async (id: number): Promise<ApiBaseResponse<GetMaliYonetimResponse> | null> => {
    try {
      const response = await api.get<ApiBaseResponse<GetMaliYonetimResponse>>(`${API_URL}/GetMaliYonetim/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  },
};

export default PortalApi;
